export default __webpack_public_path__ + "static/media/brick-driveway.1881cf28.jpg";